import { hasWindow } from "@litres/utils";
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import ru_RU from "./../../src/locales/ru-RU/translation.json";
import i18n from "../i18n";
import { initReactI18next } from "react-i18next";

const bundledResources = {
  "ru-RU": {
    translation: ru_RU,
  },
};

const getPathForProduction = (): string => {
  // Для режима разработки при работе в i18n репо выдаем локали прямо из папки src
  if (process.env.NODE_ENV === "development" && hasWindow) {
    // @ts-ignore
    if (window && window.__STORYBOOK_ADDONS) {
      return "src/locales/{lng}/{ns}.json";
    }
  }
  return "/_next/static/locales/{lng}/{ns}.json";
};

export const i18nConfig = async (): Promise<Function> => {
  return i18n
    .use(ChainedBackend)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      // the translations
      // (tip move them in a JSON file and import them,
      // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)

      lng: undefined, // Дефолтом устанавливаем ru
      fallbackLng: false, // Важно не использовать fallback, так как у нас русская строка-ключ и так фолбек
      returnEmptyString: false,
      lowerCaseLng: false,
      cleanCode: false,
      nsSeparator: "->", // Заменяем стандартный сепаратор ключей неймспейса, так как двоеточия встречаются в переводах, а дефолт i18n - ":"
      debug: false,
      supportedLngs: [
        "de-DE",
        "en-US",
        "es-ES",
        "et-EE",
        "pl-PL",
        "ru-RU",
        "uk-UA",
        "az-AZ",
        "uz-UZ",
        "tr-TR",
      ],
      saveMissing:
        process.env.NODE_ENV === "development" &&
        process.env.I18N_KEYS === "development",
      saveMissingTo: "current",
      returnNull: false,
      react: {
        //@ts-ignore
        useSuspense: !(hasWindow && window.__STORYBOOK_ADDONS),
      },
      interpolation: {
        escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        prefix: "{",
        suffix: "}",
        skipOnVariables: false,
      },

      backend: {
        backends: [
          HttpBackend,
          resourcesToBackend((lng, ns, clb): void | PromiseLike<void> => {
            bundledResources;
          }),
        ],
        backendOptions: [
          {
            loadPath: getPathForProduction(),
            addPath: "/missing-key/{lng}/",
          },
        ],
      },
    });
};
